// extracted by mini-css-extract-plugin
export default {"truncatedTextWrap":"truncated-text_truncatedTextWrap__Lw-6+"};